/* eslint-disable */
import { useState } from "react";
import { ShieldAlert, LogOut } from "lucide-react";
import { useAuth } from "../auth/AuthContext";
import { authApi } from "../auth/api";
import "./Impersonate.css";

// Pinned yellow strip shown at the top of the app while the current
// JWT has an `imp` claim. Reads from AuthContext (no props).
//
// Exit behaviour: POST /api/auth/impersonate/exit returns a TokenResponse
// for the IT_ADMIN. We swap tokens + user blob in localStorage and reload
// so every cached useState across the app is rebuilt fresh under the
// new identity — same approach the login flow uses.
export default function ImpersonationBanner() {
  const { user, isImpersonating, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (!isImpersonating) return null;

  const exit = async () => {
    setBusy(true);
    setError("");
    try {
      const tok = localStorage.getItem("access_token");
      const data = await authApi.exitImpersonation(tok);
      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("refresh_token", data.refresh_token);
      setUser(data.user);
      // Hard reload — every page-level useEffect re-runs with the
      // IT_ADMIN identity; nothing stale survives.
      window.location.assign("/");
    } catch (err) {
      setError(err?.message || "Could not exit impersonation");
      setBusy(false);
    }
  };

  return (
    <div className="vsi-banner" role="alert" aria-live="polite">
      <div className="vsi-banner-left">
        <ShieldAlert size={18} strokeWidth={2.2} />
        <div className="vsi-banner-text">
          <strong>Acting as {user?.name || user?.phone_number}.</strong>
          <span>
            Every action is recorded against this account and tagged with
            your impersonator id.
          </span>
        </div>
      </div>
      <div className="vsi-banner-right">
        {error && <span className="vsi-banner-error">{error}</span>}
        <button
          className="vsi-banner-exit"
          onClick={exit}
          disabled={busy}
          title="Return to your IT_ADMIN session"
        >
          <LogOut size={14} />
          {busy ? "Exiting…" : "Exit impersonation"}
        </button>
      </div>
    </div>
  );
}
